import { useState, type ReactNode } from 'react'
import { DeviceAgentless } from '../devices/DeviceAgentless'
import { DeviceHardwareEvents } from '../devices/DeviceHardwareEvents'
import { DeviceUpload } from '../devices/DeviceUpload'
import { AgentlessDetails } from './AgentlessDetails'

/**
 * Fisa unui aparat fara agent, deschisa sub rand - agentless/agentlessTabs.php:
 * Details / Events / Upload documents / Settings. Toate patru sunt in v4;
 * niciuna nu mai trece prin punte, fiindca portalul vechi nu mai e pe server.
 */

const TABS: { href: string; label: string }[] = [
  { href: 'inventoree/agentlessDetails/', label: 'Details' },
  { href: 'inventoree/deviceEvents/', label: 'Events' },
  { href: 'inventoree/deviceUpload/', label: 'Upload documents' },
  { href: 'inventoree/agentlessSettings/', label: 'Settings' },
]

const DETAILS = 'inventoree/agentlessDetails/'
const EVENTS = 'inventoree/deviceEvents/'
const UPLOAD = 'inventoree/deviceUpload/'
const SETTINGS = 'inventoree/agentlessSettings/'

function pane(id: number, href: string): ReactNode {
  const props = { id, from: 'inventoree', overview: [], screen: () => null, open: () => undefined }
  if (href === EVENTS) return <DeviceHardwareEvents {...props} />
  if (href === UPLOAD) return <DeviceUpload {...props} />
  if (href === SETTINGS) return <DeviceAgentless {...props} />
  return <AgentlessDetails {...props} />
}

export function AgentlessWorkspace({ id }: { id: number }) {
  const [active, setActive] = useState(DETAILS)
  const current = TABS.find((t) => t.href === active) ?? TABS[0]

  return (
    <div className="row d-flex m-0">
      <div className="col-auto bg-lightest-gray">
        <ul className="action_tabs">
          {TABS.map((t) => (
            <li key={t.href}>
              <a
                href={`/app/${t.href}${id}`}
                className={`action_button${active === t.href ? ' active' : ''}`}
                onClick={(e) => {
                  e.preventDefault()
                  setActive(t.href)
                }}
              >
                {t.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-md-12">
        <div className="details_content">{pane(id, current.href)}</div>
      </div>
    </div>
  )
}
